import Alfalfa from '../../../assets/images/plants/alfalfa.jpeg'
import BlackNightshare from '../../../assets/images/plants/black_nightshare.jpg'
import HairyBittercress from '../../../assets/images/plants/hairy_bittercress.jpeg'

const JapanesePlantData = {
  "data": [
    {
      "id": 155041,
      "common_name": "Alfalfa",
      "slug": "medicago-sativa",
      "scientific_name": "Medicago sativa",
      "year": 1753,
      "bibliography": "Sp. Pl.: 778 (1753)",
      "author": "L.",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Pea family",
      "genus_id": 4511,
      "image": Alfalfa,
      "synonyms": [
        "Trigonella upendrae",
        "Medicago sativa subsp. caerulea",
        "Medicago tadzhicorum",
        "Medicago kopetdaghi",
        "Medica legitima",
        "Medicago sativa subsp. vulgaris",
        "Medicago sativa subsp. macrocarpa",
        "Medicago orientalis",
        "Medicago polia",
        "Medicago sogdiana",
        "Medicago eusativa",
        "Medicago praesativa",
        "Medicago sativa f. alba",
        "Medicago asiatica",
        "Medicago sativa var. polia",
        "Medicago transoxana",
        "Medicago afghanica",
        "Medicago jemenensis",
        "Medicago sativa f. salaverryensis",
        "Medicago mesopotamica",
        "Medicago sativa var. integrifoliola",
        "Medicago karatschaica",
        "Medicago tripolitanica",
        "Medicago contorta",
        "Medicago syriacopalestinica",
        "Medicago sativa subsp. microcarpa"
      ],
      "genus": "Medicago",
      "family": "Fabaceae",
      "links": {
        "self": "/api/v1/species/medicago-sativa",
        "plant": "/api/v1/plants/medicago-sativa",
        "genus": "/api/v1/genus/medicago"
      }
    },
    {
      "id": 182543,
      "common_name": "Black nightshade",
      "slug": "solanum-nigrum",
      "scientific_name": "Solanum nigrum",
      "year": 1753,
      "bibliography": "Sp. Pl.: 186 (1753)",
      "author": "L.",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Potato family",
      "genus_id": 4329,
      "image": BlackNightshare,
      "synonyms": [
        "Solanum viride",
        "Solanum decurrens",
        "Solanum diffusum",
        "Solanum cuneifolium",
        "Solanum nigrum var. incisum",
        "Solanum chenopodiifolium",
        "Solanum nigrum var. stylosum",
        "Solanum paludosum",
        "Solanum tauschii",
        "Solanum nigrum var. vulgatum",
        "Solanum foetidum",
        "Solanum acutifolium",
        "Solanum speciosum",
        "Solanum fontanesianum",
        "Solanum nigrum var. atriplicifolium",
        "Solanum cestrophyllum",
        "Solanum nigrum var. chlorocarpum",
        "Solanum nigrum var. flavidum",
        "Solanum probstianum",
        "Solanum chlorocarpum",
        "Solanum bidentatum",
        "Solanum nigrum var. elbaensis",
        "Solanum nigrum var. genuinum",
        "Solanum besserianum",
        "Solanum nigrum subsp. schultesii",
        "Solanum cechicum",
        "Solanum schultesii",
        "Solanum ganchouenense",
        "Solanum moschatum",
        "Solanum parviflorum",
        "Solanum roxburghii",
        "Solanum repens",
        "Solanum cestrifolium",
        "Solanum nigrum f. longepedunculatum",
        "Solanum nigrum inerme",
        "Solanum nigrum var. legitimum",
        "Solanum exaratum",
        "Solanum chenopodium",
        "Solanum decipiens",
        "Solanum extremiorientale",
        "Solanum judaicum",
        "Solanum vulgare",
        "Solanum vulgatum",
        "Solanum pseudoflavum",
        "Solanum rottboellianum",
        "Solanum nigrum var. hirsutum",
        "Solanum peregrinum",
        "Solanum reineggeri",
        "Solanum rhinozerothis",
        "Solanum astroites",
        "Solanum nigrum var. subhastatum",
        "Solanum stenopetalum",
        "Solanum viscosum",
        "Solanum salzmannii",
        "Solanum epibyssinum",
        "Solanum viridifolium"
      ],
      "genus": "Solanum",
      "family": "Solanaceae",
      "links": {
        "self": "/api/v1/species/solanum-nigrum",
        "plant": "/api/v1/plants/solanum-nigrum",
        "genus": "/api/v1/genus/solanum"
      }
    },
    {
      "id": 115789,
      "common_name": "Hairy bittercress",
      "slug": "cardamine-hirsuta",
      "scientific_name": "Cardamine hirsuta",
      "year": 1753,
      "bibliography": "Sp. Pl.: 655 (1753)",
      "author": "L.",
      "status": "accepted",
      "rank": "species",
      "family_common_name": "Mustard family",
      "genus_id": 1453,
      "image": HairyBittercress,
      "synonyms": [
        "Cardamine hirsuta subsp. sylvatica",
        "Cardamine hirsuta var. flaccida",
        "Cardamine hirsuta var. sylvatica",
        "Cardamine hirsuta subsp. hirsuta",
        "Cardamine hirsuta var. formosana",
        "Cardamine hirsuta var. hirsuta",
        "Cardamine hirsuta subsp. flexuosa",
        "Cardamine hirsuta fo. pensylvanica",
        "Cardamine scutata var. formosana",
        "Cardamine multicaulis",
        "Cardamine hirsuta var. latifolia",
        "Cardamine hirsuta var. regeliana",
        "Cardamine hirsuta var. rotundiloba",
        "Cardamine hirsuta subsp. kamtschatica",
        "Cardamine hirsuta var. parviflora",
        "Cardamine tenella",
        "Cardamine hirsuta var. oxycarpa",
        "Cardamine hirsuta var. apetala",
        "Cardamine hirsuta f. unicaulis",
        "Cardamine praecox",
        "Cardamine humilis",
        "Ghinia sylvatica",
        "Ghinia hirsuta",
        "Cardamine micrantha",
        "Cardamine hirsuta var. pilosa",
        "Cardamine fagetina",
        "Cardamine hirsuta var. montana",
        "Cardamine hirsuta var. unicaulis",
        "Cardamine tetrandra",
        "Cardamine simensis",
        "Cardamine hirsuta var. petiolulata",
        "Crucifera cardamine"
      ],
      "genus": "Cardamine",
      "family": "Brassicaceae",
      "links": {
        "self": "/api/v1/species/cardamine-hirsuta",
        "plant": "/api/v1/plants/cardamine-hirsuta",
        "genus": "/api/v1/genus/cardamine"
      }
    }
  ],
  "links": {
    "self": "/api/v1/plants?page=5\u0026zone_id=jap",
    "first": "/api/v1/plants?page=1\u0026zone_id=jap",
    "prev": "/api/v1/plants?page=4\u0026zone_id=jap",
    "next": "/api/v1/plants?page=6\u0026zone_id=jap",
    "last": "/api/v1/plants?page=255\u0026zone_id=jap"
  },
  "meta": { "total": 5082 }
}

export default JapanesePlantData